import { useState, useRef, useCallback, useEffect } from 'react';
import Draggable from 'react-draggable';
import { useRefs } from 'react-context-refs';
import { clamp } from 'Utils';
import { setProgressCompleted } from 'Actions';
import { useDispatch, useSelector } from 'react-redux';
import {
	AudioTimeline,
	ProgressLoaded,
	ProgressValue,
	ProgressThumb
} from 'Styles';
import styles from 'partials/player-timeline.module.scss';

export const Timeline = ({ isSelected }) => {
	const [position, setPosition] = useState({ x: -8, y: 0 });
	const track = useSelector(state => state.player)
	const dispatch = useDispatch()
	const currentPlayer = useRefs().map((ref) => ref.current)[0];
	const timeline = useRef(null);

	const setUpdateTime = useCallback(
		(seek) => {
			let updateTime = (seek + 8) / timeline.current.offsetWidth;
			updateTime = clamp(updateTime, 0, 1);
			currentPlayer.seekTo(updateTime);
			dispatch(setProgressCompleted(updateTime * 100));
		},
		[dispatch, currentPlayer]
	);

	const handleProgress = useCallback(() => {
		let leftPropgress = isSelected
			? (track.progressCompleted / 100) * timeline.current.offsetWidth - 8
			: -8;
		let position = {
			x: leftPropgress,
			y: 0
		};
		setPosition(position);
	}, [track.progressCompleted, isSelected]);

	const handleStop = useCallback(
		(e, ui) => {
			e.stopPropagation();
			isSelected && setUpdateTime(ui.x);
		},
		[setUpdateTime, isSelected]
	);

	const handleDrag = useCallback(
		(e, ui) => {
			e.stopPropagation();
			let position = {
				x: ui.x,
				y: 0
			};
			isSelected && setPosition(position);
			isSelected && setUpdateTime(ui.x);
		},
		[setUpdateTime, isSelected]
	);

	useEffect(() => {
		handleProgress();
	}, [handleProgress]);

	return (
		<AudioTimeline className={styles.timeline} ref={timeline}>
			<ProgressLoaded
				className={styles.bar}
				style={{
					width: isSelected
						? track.progressLoaded.toFixed(2) + '%'
						: 0
				}}
			/>
			<ProgressValue
				className={styles.bar}
				style={{
					width: isSelected
						? track.progressCompleted.toFixed(2) + '%'
						: 0
				}}
			/>
			<Draggable
				axis="x"
				bounds="parent"
				onStop={handleStop}
				onDrag={handleDrag}
				position={position}
				defaultPosition={{ x: -8, y: 0 }}>
				<ProgressThumb className={styles.thumb} />
			</Draggable>
		</AudioTimeline>
	);
};
